import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ValuationFiltersSubmit } from '../../components/ValuationFiltersSubmit';
import { useButtonText } from './utils';
import { useHandleSubmit } from './utils/useHandleSubmit';
import { selectEstimationByDealType } from '../../selectors/estimation';
import { selectFilters } from '../../selectors/filters';
import { selectCheckEstimationExists } from '../../selectors/checkEstimationExists/selectCheckEstimationExists';
import { useHandleValuationSubmit } from './utils/useHandleValuationSubmit';
import { resetCheckEstimationExists } from '../../actions/checkEstimationExists';
import { selectDealType } from '../../selectors/page';

export function ValuationFiltersSubmitContainer() {
  const dispatch = useDispatch();
  const dealType = useSelector(selectDealType);
  const { isFetching } = useSelector(selectEstimationByDealType(dealType));
  const { estimationTarget, address } = useSelector(selectFilters);
  const { isNotFound, estimationId, isFetching: isLoadingCheckEstimation } = useSelector(selectCheckEstimationExists);

  const handleValuationSubmit = useHandleValuationSubmit();

  const handleSubmit = useHandleSubmit();
  const buttonText = useButtonText();

  const onEstimationReadyClick = React.useCallback(() => {
    handleValuationSubmit();
  }, [handleValuationSubmit]);

  React.useEffect(() => {
    dispatch(resetCheckEstimationExists());
  }, [dispatch, address]);

  return (
    <ValuationFiltersSubmit
      isFetching={isFetching || isLoadingCheckEstimation}
      buttonText={buttonText}
      estimationTarget={estimationTarget}
      onClick={handleSubmit}
      onEstimationReadyClick={onEstimationReadyClick}
      isNotFound={isNotFound}
      isEstimationReady={Boolean(estimationId)}
    />
  );
}
